export const MOBILE_BREAKPOINT = 770;
export const TABLET_BREAKPOINT = 1024;

const BREAKPOINTS = {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
};

export default BREAKPOINTS;
